import React, { useState } from 'react';
import DashboardLayout from './DashboardLayout';
import IntelligenceTable from './IntelligenceTable';
import NewsDashboard from './NewsDashboard';
import PdfTable from './PdfTable';
import RequestForm from './RequestForm';
import BotResultsTable from './BotResultsTable';
import DashboardOverview from './DashboardOverview';
import IntelligenceSources from './IntelligenceSources';
import GraphAnalytics from './GraphAnalytics';
import KnowledgeGraphPage from './KnowledgeGraphPage';
import OmniSearch from './OmniSearch';
import WhiteboardPage from './WhiteboardPage';
import '../styles/KnowledgeGraphNew.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('intelligence');
  const [selectedBot, setSelectedBot] = useState(null);
  const [initialBoardId, setInitialBoardId] = useState(null);
  const [initialEntityId, setInitialEntityId] = useState(null);
  const [initialEntityName, setInitialEntityName] = useState(null);

  const handleViewInGraph = () => {
    setInitialEntityId(null);
    setInitialEntityName(null);
    setActiveTab('knowledge-graph');
  };

  // Called by GraphAnalytics when user clicks a "view in context" link on an insight card
  const handleAnalyticsNavigate = (tab, params = {}) => {
    console.log(`[Dashboard] Analytics navigate → ${tab}`, params);
    if (tab === 'whiteboard') {
      setInitialBoardId(params.boardId || null);
    } else if (tab === 'knowledge-graph') {
      setInitialEntityId(params.entityId || null);
      setInitialEntityName(params.entityName || null);
    }
    setActiveTab(tab);
  };

  // Explicit conditional rendering - only render the active component
  // This ensures complete unmounting of inactive components
  return (
    <DashboardLayout 
      activeTab={activeTab} 
      setActiveTab={(tab) => {
        // Log tab switches for debugging memory issues
        console.log(`[Dashboard] Switching from ${activeTab} to ${tab}`);
        
        if (tab !== 'knowledge-graph') {
          setInitialEntityId(null);
          setInitialEntityName(null);
        }
        if (tab !== 'whiteboard') {
          setInitialBoardId(null);
        }
        setActiveTab(tab);
      }}
      selectedBot={selectedBot}
      setSelectedBot={setSelectedBot}
    >
      {/* Only mount the active component - explicit conditional rendering */}
      {activeTab === 'overview' && <DashboardOverview key="overview" />}
      {activeTab === 'bots' && <BotResultsTable key="bots" selectedBot={selectedBot} />}
      {activeTab === 'intelligence' && <IntelligenceTable key="intelligence" />}
      {activeTab === 'intelligence-sources' && <IntelligenceSources key="intelligence-sources" onViewInGraph={handleViewInGraph} />}
      {activeTab === 'intelligence-analytics' && <GraphAnalytics key="analytics" onNavigate={handleAnalyticsNavigate} />}
      {activeTab === 'news' && <NewsDashboard key="news" />}
      {activeTab === 'pdf' && <PdfTable key="pdf" />}
      {activeTab === 'requests' && <RequestForm key="requests" />}
      {activeTab === 'omni-search' && <OmniSearch key="omni-search" />}
      {activeTab === 'whiteboard' && <WhiteboardPage key="whiteboard" initialBoardId={initialBoardId} />}
      {activeTab === 'knowledge-graph' && <KnowledgeGraphPage key="knowledge-graph" initialEntityId={initialEntityId} initialEntityName={initialEntityName} />}
    </DashboardLayout>
  );
};

export default Dashboard;
